import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import borluulalt from "../../assets/images/Borluulalt.svg";
import burtgel from "../../assets/images/Burtgel.svg";
import tailan from "../../assets/images/Tailan.svg";
import tohirgoo from "../../assets/images/Tohirgoo.svg";
import toollogo from "../../assets/images/Toollogo.svg";
import orlogo from "../../assets/images/Orlogo.svg";
import { MAIN_MENU } from "../../data";
import { Layout } from "antd";
import UsefulFunctions from "../../utils/UsefulFunctions";
import * as Components from "../../components";
import { Button } from "antd";
function Home(props) {
  const navigate = useNavigate();
    const [isOpen, setIsOpenModal] = useState(localStorage.getItem("isshow")==="false"?false:true
                ? localStorage.getItem("isshow")
                : true);
  const [data, setData] = useState(JSON.parse(localStorage.getItem("auth")));
                

  useEffect(() => {
    document.title = "Нүүр хуудас";
  }, []);

  const navigateWindow = ({ route }) => {
    navigate(route);
  };

  const getImage = (img) => {
    switch (img) {
      case "borluulalt":
        return borluulalt;
      case "burtgel":
        return burtgel;
      case "tailan":
        return tailan;
      case "tohirgoo":
        return tohirgoo;
      case "toollogo":
        return toollogo;
      case "orlogo":
        return orlogo;
      default:
        return borluulalt;
    }
  };

  const getCards = (item) => {
    let content = (
      <div
        className="rounded-t-2xl relative"
        onClick={() =>
          navigateWindow({
            route: item.route,
            type: item.type,
          })
        }
      >
        <div className="relative cursor-pointer drop-shadow-xl p-5 rounded-lg flex justify-center">
          <img
            src={getImage(item.img)}
            alt=""
            className="rounded-2xl object-cover w-60 h-56"
          />
          <div className="absolute bottom-0 w-full px-2 opacity-70 ">
            <div className="w-full p-2 text-xl text-center font-bold text-black uppercase bg-white rounded-2xl">
              {item.name}
            </div>
          </div>
        </div>
      </div>
    );
    let res = UsefulFunctions.checkPermission(props._auth, item.permission);
    if (res) return content;
    return null;
  };

  return (
    <Layout className="items-center justify-center h-full">
      <div className="lg:p-5 items-center grid lg:grid-cols-3 justify-center overflow-auto flex-wrap gap-6 lg:w-2/4">
       <Components.GlobalModal
        footer={[
          <Button type="primary" onClick={() => (localStorage.setItem("isshow", "false"),setIsOpenModal(false))}autoFocus>
            Ойлголоо
          </Button>,
        ]}
        width={400}
        isOpen={ isOpen}
        onClose={() => (localStorage.setItem("isshow", "false"),setIsOpenModal(false))}
        title="Анхааруулга"
      >
        <div className="py-3 px-10 flex flex-col items-center justify-center">
          <span className="text-center"><b>Хэрэглэгч <b style={{ color: 'red' }}>{`${data && data.user?.lastname}`}</b> та Automotive програм-д тавтай морилно уу.<b style={{ color: 'red' }}>Та {data && data.user?.storename} салбараар нэвтэрсэн байна.</b></b></span>
        </div>
      </Components.GlobalModal>
        {MAIN_MENU({ ...props }).map((item, i) => getCards(item))}
      </div>
    </Layout>
  );
}
export default Home;
